module.exports = __webpack_public_path__ + "img/events_back.72d49f9c.jpg";